import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { eventPlatformApi, type DomainEvent } from '../../api/eventplatform';

export function EventExplorerPage() {
  const [events, setEvents] = useState<DomainEvent[]>([]);
  const [filter, setFilter] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    void eventPlatformApi.listEvents({ event_name: filter || undefined, limit: 100 })
      .then((r) => setEvents(r.events))
      .catch((e) => setError(String(e)));
  }, [filter]);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/events" className="text-sm text-blue-600 hover:underline">← Event Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Event Explorer</h1>
      <input value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter by event name" className="mt-4 rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900" />
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <table className="mt-6 w-full text-left text-sm">
        <thead><tr className="border-b dark:border-slate-700"><th className="py-2">Name</th><th>Kind</th><th>Tenant</th><th>Time</th></tr></thead>
        <tbody>
          {events.map((e) => (
            <tr key={e.id} className="border-b dark:border-slate-800">
              <td className="py-2 font-mono">{e.name}</td>
              <td>{e.kind}</td>
              <td>{e.tenant_id ?? '—'}</td>
              <td>{e.timestamp}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
